import { createTheme, TextField, ThemeProvider } from "@mui/material";
import { useRef } from "react";

interface FormBasicInputProps {
  label: any;
  title: string;
  setValue: any;
  value: any;
  icon?: any;
  displayEdit?: any;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  pnSimilarSelect?: any;
  width?: string | number;
  className?: string;
  maxLength?: number;
}

const FormBasicInput = ({
  title,
  label,
  setValue,
  value,
  width = "40ch",
  className,
  maxLength,
  inputProps,
}: FormBasicInputProps) => {
  const customTheme = createTheme({
    palette: { primary: { main: "#000000" } },
  });

  const textFieldRef = useRef<HTMLInputElement>(null);

  const valueInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <ThemeProvider theme={customTheme}>
        <h4>{title}</h4>
        <p className="lineLabel lineLabelSmallInput">{label}</p>
        <div
          className={className}
          style={{
            width: "40ch",
            position: "relative",
            marginTop: "15px",
          }}
        >
          <TextField
            inputRef={textFieldRef}
            value={value}
            onChange={valueInput}
            id="filled-basic"
            className={className}
            variant="filled"
            focused
            multiline
            inputProps={{
              ...inputProps,
              maxLength,
            }}
            rows={3}
            sx={{
              "& > :not(style)": { width: width },
              "& .MuiFilledInput-root": {
                borderRadius: "0px",
                backgroundColor: "#E0E2E5",
                fontSize: "17px",
                overflowY: "auto",
              },
              "& .MuiInputBase-input": {
                marginTop: "-22px",
                height: "100px",
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
                paddingRight: "10px",
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                },
              },
            }}
          />
        </div>
      </ThemeProvider>
    </div>
  );
};

export default FormBasicInput;
